/**
 * Created with JetBrains WebStorm.
 * User: sebastienbeaujard
 * Date: 10/01/2014
 * Time: 08:10
 * To change this template use File | Settings | File Templates.
 */

angular.module('FlexyBeautyApp.services').
    factory('CureCategoryView',["$log","CureView","CureCategoryData","CureData","CureCategory","CureCategorySrv","CureSrv","StyleColor","ItemCategoryView",
        function ($log,CureView,CureCategoryData,CureData,CureCategory,CureCategorySrv,CureSrv,StyleColor,ItemCategoryView)
        {

        var  CureCategoryView = function (category,catIndex,parentCategoryView,domainView)
        {
            ItemCategoryView.call(this);

            this.catIndex = catIndex;
            this.domainView = domainView;
            this.label = "";
            this.description = "";
            this.curesView = [];
            this.categoriesView = [];
            this.image = null;
            this.companyImage = null;
            this.imageDisplayed = null; //eguals to companyImage if defined else GlobalImage
            this.styleView = {};  //styleView is an object and category.style is a string
            this.colorPicker = ""; //value liked by the colorpicker
            this.specificImage = null;
            this.isVisibleOnWebSite = true;
            this.parentCategoryView = null;
            this.isSelResKnow = false; // if the selected Ressource know at least one service of the category
            this.selectedCureView=null;
            this.displayType ="array";// only on view loaded by web site theme    //thumbnail //array //selector-array //selector-image
            this.displayCureImages = true;// only on view if children images are different than son

            if (parentCategoryView!==undefined && parentCategoryView!=null)
                this.parentCategoryView=  parentCategoryView;

            this.styleView = this.getStyleFrom(category);
            if (this.styleView)
                this.colorPicker = this.styleView.background;

            if (category!==undefined && category!=null)
            {
                var cureView;
                this.loadDataFrom(category);
                for (var i=0;i< category.categories.length;i++)
                    this.categoriesView.push(new CureCategoryView(category.categories[i],CureCategoryData.getIndexOf(category.categories[i]),this,domainView));
                for (var j=0;j< category.cures.length;j++)
                {
                    cureView  = new CureView(category.cures[j],CureData.getIndexOf(category.cures[j]),this,domainView);
                    this.curesView.push(cureView);
                    if (this.domainView && this.domainView.addCureViewIndex!==undefined)
                        this.domainView.addCureViewIndex(cureView);
                }
            }
        }

        CureCategoryView.prototype = Object.create(ItemCategoryView.prototype);//inherit functions from ItemCategoryView

        CureCategoryView.prototype.setImage = function(image)
        {
            for (var j=0;j< this.curesView.length;j++)
                if (this.curesView[j].image==null && !this.curesView[j].specificImage)//if same than previous change
                    this.curesView[j].setImage(image)
            this.image = image;
            this.companyImage = null;
            this.imageDisplayed = this.image;

        }

        CureCategoryView.prototype.setCompanyImage = function(companyImage)
        {
            for (var j=0;j< this.curesView.length;j++)
                if (this.curesView[j].companyImage==null && !this.curesView[j].specificImage)//if same than previous change
                    this.curesView[j].setImage(companyImage)
            this.image = null;
            this.companyImage = companyImage;
            this.imageDisplayed = this.companyImage;
        }

        CureCategoryView.prototype.getCategoryView  = function(category)
        {
            var categoryView =null;
            if (this.getModel()===category)
                return this;
            for (var i=0;i< this.categoriesView.length && categoryView==null;i++)
                categoryView = this.categoriesView[i].getCategoryView(category);
            return categoryView;
        }

        CureCategoryView.prototype.getCureView  = function(cure)
        {
            var cureView = null;
            for (var j = 0; j < this.curesView.length; j++)
                if (this.curesView[j].getModel() === cure)
                    return this.curesView[j];
            for (var z=0;z< this.categoriesView.length && !cureView;z++)
                cureView = this.categoriesView[z].getCureView(cure);

            return cureView;
        };
            CureCategoryView.prototype.getCureViewById  = function(id)
            {
                var cure;
                for (var j = 0; j < this.curesView.length; j++)
                {
                    cure = this.curesView[j].getModel();
                    if (cure && cure.id == id)
                        return this.curesView[j];
                }
                var cureView = null;
                for (var z=0;z< this.categoriesView.length&&!cureView ;z++)
                    cureView = this.categoriesView[z].getCureViewById(id);
                return cureView;
            };
            CureCategoryView.prototype.getCategoryViewById  = function(id)
            {
                var categoryView = null;
                var category = this.getModel();
                if (category && category.id ==id)
                    return this;
                for (var z=0;z< this.categoriesView.length && !categoryView;z++)
                    categoryView = this.categoriesView[z].getCategoryViewById(id);
                return categoryView;
            };

            CureCategoryView.prototype.getAllCuresView  = function(cure)
        {
            var lCuresView = this.curesView.slice(0);

            var array;
            for (var z=0;z< this.categoriesView.length;z++)
            {
                array = this.categoriesView[z].getAllCuresView();
                if (array)
                    for(var j = 0; j < array.length; j++)
                        lCuresView.push(array[j])
            }


            return lCuresView;
        }

        CureCategoryView.prototype.getCureViewByCode  = function(code)
        {
            var cureView = null;
            for (var j = 0; j < this.curesView.length; j++)
                if (this.curesView[j].code == code)
                    return this.curesView[j];
            for (var z=0;z< this.categoriesView.length && !cureView;z++)
                cureView = this.categoriesView[z].getCureViewByCode(code);
            return cureView;
        }

        CureCategoryView.prototype.copyDataTo = function(category)
        {
            //Assume here than the object in parameter contains only id (must load them)
            category.label = this.label;
            category.description = this.description;
            if (this.parentCategoryView && this.styleView===this.parentCategoryView.styleView)// if is specific set it
                category.style = null;
            else
                category.style = angular.toJson(this.styleView);
            category.image = this.image;
            category.companyImage = this.companyImage;
            category.specificImage = this.specificImage;
            category.isVisibleOnWebSite = this.isVisibleOnWebSite;

        }

        CureCategoryView.prototype.loadDataFrom = function(category)
        {
            this.label = category.label;
            this.description = category.description;
            this.image = category.image;
            this.companyImage = category.companyImage;
            this.specificImage = category.specificImage;
            if (this.companyImage)
                this.imageDisplayed = this.companyImage;
            else
                this.imageDisplayed = this.image;
            this.isVisibleOnWebSite = category.isVisibleOnWebSite;
        }

        CureCategoryView.prototype.onStyleViewChange = function()
        {
            var fontColor = StyleColor.getContrastYIQ(this.colorPicker);
            if (!this.styleView || this.styleView.background !=this.colorPicker)
            {
                if (!this.styleView ||//if undefined
                    (this.parentCategoryView && this.parentCategoryView.styleView===this.styleView ))// if same than parent : break inheritance
                    this.styleView = {};
                this.styleView.background  = this.colorPicker;
                this.styleView.color  = fontColor;
                this.updateStyleView();
            }
        }

        CureCategoryView.prototype.updateStyleView = function(styleView)
        {
            for (var j=0;j< this.categoriesView.length;j++)
                if (this.categoriesView[j].styleView==null)//if same than previous change
                    this.categoriesView[j].updateStyleView(styleView)
        }

        CureCategoryView.prototype.getStyleFrom = function(category)
        {
            var styleView = null;
            if (category)
                if (category.style && category.style.indexOf('{')!=0) //Previous type before 1.5 was not contains a jsonSTring
                    styleView = null;
                else
                    try {
                        styleView = angular.fromJson(category.style);
                    }
                    catch (ex) {
                        console.log("Error loading style")
                    }
            if (!styleView)
                if (this.parentCategoryView!=null)
                    styleView = this.parentCategoryView.styleView;
            return styleView;
        };

        CureCategoryView.prototype.populateHomeItemsView = function(homeItemsView) {
            for (var i=0;i< this.categoriesView.length;i++)
                this.categoriesView[i].populateHomeItemsView(homeItemsView);
            for (var j=0;j< this.curesView.length;j++)
                if(this.curesView[j].isOnHome)
                    homeItemsView.push({type:'cure', item : this.curesView[j],active:false});
        };

        CureCategoryView.prototype.isChanged = function()
        {
            var category = this.getModel();
            if (category)
            {
                /*var image = category.image;
                if ((image==null||image=="") &&this.parentCategoryView)
                    image = this.parentCategoryView.image;*/
                var styleView  = this.getStyleFrom(category);
                var styleChanged = (this.styleView && !styleView) ||
                    !this.styleView && styleView ||
                    (this.styleView && styleView &&
                     this.styleView.background != styleView.background);
                return (
                    this.label != category.label ||
                    this.description != category.description ||
                    styleChanged ||
                    this.image != category.image ||
                    this.companyImage !=  category.companyImage
                );

            }
            else
                return true;

        }

        CureCategoryView.prototype.getModel = function()
        {
            if (this.catIndex!=-1)
                return CureCategoryData.getByIndex(this.catIndex);
            return null;
        }

        CureCategoryView.prototype.restoreModel = function()
        {   //undeleted
            var category = this.getModel();
            if (category)
            {
                if (category.parentCategory)
                    category.parentCategory.addCategory(category);
                CureCategorySrv.restore(category);
            }

        }

        CureCategoryView.prototype.updateModel = function()
        {
            var category = this.getModel();
            if (category==null)
            {
                category = new CureCategory();
                this.catIndex = CureCategoryData.getIndexOf(category);
            }

            this.copyDataTo(category);
            if (this.parentCategoryView) {
                var parentCategory = this.parentCategoryView.getModel();
                if (parentCategory && parentCategory !== category.parentCategory) // change of category
                {
                    if (category.parentCategory)
                        category.parentCategory.removeCategory(category);
                    parentCategory.addCategory(category);
                }
            }
            category.categories = [];
            for (var i=0;i<this.categoriesView.length;i++)
                category.addCategory(this.categoriesView[i].getModel());
            category.cures = [];
            for (var i=0;i<this.curesView.length;i++)
                category.addCure(this.curesView[i].getModel());
            //modify order of categories

            CureCategorySrv.save(category, null, this.checkForRootSaveError);
        }

        CureCategoryView.prototype.reloadModel = function()
        {
            var category = this.getModel();
            if (category == null)
            {
                this.parentCategoryView.removeCategoryView(this);
            }
            else
            {
                var styleView = this.getStyleFrom(category);
                if (this.styleView && styleView)
                {
                    this.styleView.background = styleView.background;
                    this.styleView.color = styleView.color;
                }
                else
                    this.styleView = styleView;

                if (this.styleView)
                this.colorPicker = this.styleView.background;

                this.loadDataFrom(category)
            }
        }

        CureCategoryView.prototype.removeModel = function()
        {
            var category = this.getModel();
            if (category!=null)
            {
                if (category.parentCategory)
                    category.parentCategory.removeCategory(category);
                CureCategorySrv.remove(category);
            }
        }

        CureCategoryView.prototype.removeSelections = function()
        {
            //if one cure is known by humanResource : category is known
            for (var i=0;i< this.categoriesView.length;i++)
                this.categoriesView[i].removeSelections();
            for (var j=0;j< this.curesView.length;j++)
                this.curesView[j].isSelected=false;
        }

        CureCategoryView.prototype.addCategoryView = function(categoryView)
        {
            var index = this.categoriesView.indexOf(categoryView);
            if (index==-1)
            {
                this.categoriesView.push(categoryView);
                categoryView.parentCategoryView = this;
            }
        }
        
        CureCategoryView.prototype.removeCategoryView = function(categoryView)
        {
            var index = this.categoriesView.indexOf(categoryView);
            if (index!=-1)
                this.categoriesView.splice(index,1);


        }

        CureCategoryView.prototype.addCureView = function(cureView)
        {
            var index = this.curesView.indexOf(cureView);
            if (index==-1)
            {
                this.curesView.push(cureView);
                cureView.parentCategoryView = this;
            }
        }

        CureCategoryView.prototype.removeCureView = function(cureView)
        {
            var index = this.curesView.indexOf(cureView);
            if (index!=-1)
            {
                this.curesView.splice(index,1);
            }
        }

        CureCategoryView.prototype.changeCategoryPosition = function(scope,categoryView,indexTarget)
        {
            var category = this.getModel();
            var index = this.categoriesView.indexOf(categoryView);
            //Todo check indexTarget!=index
            if (category && indexTarget!=-1 && index!=-1 &&  this.categoriesView && indexTarget<=this.categoriesView.length)
            {
                this.categoriesView.splice(index,1); //remove it
                category.categories.splice(index,1);
                scope.$apply();//TODO CHECK WHY Two APPLYs ARE NEEDED
                if (index<indexTarget)
                    indexTarget--;
                if (indexTarget==this.categoriesView.length)
                {
                    this.categoriesView.push(categoryView);
                    category.categories.push(categoryView.getModel());
                }
                else
                {
                    this.categoriesView.splice(indexTarget,0,categoryView);//insert
                    category.categories.splice(indexTarget,0,categoryView.getModel());
                }
                CureCategorySrv.save(category, null, this.checkForRootSaveError);
            }
            scope.$apply();
        };

        CureCategoryView.prototype.changeCategoryPositionView = function(categoryView,indexTarget)
        {
            //Change the category position
            // This : parentCategory
            // categoryView : category to move to indexTarget
            var index = this.categoriesView.indexOf(categoryView);
            if (indexTarget!=-1 && index!=-1 &&  this.categoriesView && indexTarget<=this.categoriesView.length)
            {
                this.categoriesView.splice(index,1); //remove it
                if (indexTarget==this.categoriesView.length)
                    this.categoriesView.push(categoryView);
                else
                    this.categoriesView.splice(indexTarget,0,categoryView);//insert
            }
        };

        CureCategoryView.prototype.changeCurePositionView = function(cureView,indexTarget)
        {
            //Change the cure position

            var index = this.curesView.indexOf(cureView);
            //Todo check indexTarget!=index
            if (indexTarget!=-1 && index!=-1 &&  this.curesView && indexTarget<=this.curesView.length)
            {
                this.curesView.splice(index,1); //remove it
                if (indexTarget==this.curesView.length)
                    this.curesView.push(cureView);
                else
                    this.curesView.splice(indexTarget,0,cureView);//insert
            }
        }

        CureCategoryView.prototype.changeCurePosition = function(scope,cureView,indexTarget)
        {

            var category = this.getModel();
            var index = this.curesView.indexOf(cureView);
            //Todo check indexTarget!=index
            if (category && indexTarget!=-1 && index!=-1 &&  this.curesView && indexTarget<=this.curesView.length)
            {
                this.curesView.splice(index,1); //remove it
                category.cures.splice(index,1);
                scope.$apply();//TODO CHECK WHY TO APPLY ARE NEEDED
                if (index<indexTarget)
                    indexTarget--;
                if (indexTarget==this.curesView.length)
                {
                    this.curesView.push(cureView);
                    category.cures.push(cureView.getModel());
                }
                else
                {
                    this.curesView.splice(indexTarget,0,cureView);//insert
                    category.cures.splice(indexTarget,0,cureView.getModel());
                }
                CureCategorySrv.save(category, null, this.checkForRootSaveError);
                scope.$apply();

            }
        }

        CureCategoryView.prototype.moveCure = function(cureView)
        {
            if (cureView)
            {
                var cure = cureView.getModel();
                var category = this.getModel();
                if (cure && category)
                {
                    if (cureView.parentCategoryView)
                    {
                        var index = cureView.parentCategoryView.curesView.indexOf(cureView);
                        if (index!=-1)
                        {
                            cureView.parentCategoryView.curesView.splice(index,1);
                            cure.parentCategory.cures.splice(index,1);

                        }
                    }
                    this.addCureView(cureView);
                    category.addCure(cure)
                    CureSrv.save(cure);
                }
            }
        }

        CureCategoryView.prototype.moveCategory = function(categoryView)
        {
            if (categoryView)
            {
                var categoryToMove = categoryView.getModel();
                var category = this.getModel();
                if (categoryToMove && category)
                {
                    if (categoryView.parentCategoryView)
                    {
                        var index = categoryView.parentCategoryView.categoriesView.indexOf(categoryView);
                        if (index!=-1)
                        {
                            categoryView.parentCategoryView.categoriesView.splice(index,1);
                            categoryToMove.parentCategory.categories.splice(index,1);
                        }

                    }
                    this.addCategoryView(categoryView)
                    category.addCategory(categoryToMove)
                    CureCategorySrv.save(categoryToMove, null, this.checkForRootSaveError);
                }
            }
        }

        CureCategoryView.prototype.canSave = function()
        {
            return (this.label && this.label!="" )

        };

        CureCategoryView.prototype.initWebDisplay = function(forceTo)
        {
            for (var i=0;i< this.categoriesView.length;i++)
                this.categoriesView[i].initWebDisplay(forceTo);

            this.displayCureImages = false;
            for (var j=0;j< this.curesView.length && !this.displayCureImages;j++)
                if (this.curesView[j].imageDisplayed!==this.imageDisplayed)
                    this.displayCureImages = true;
            for (var j=0;j< this.categoriesView.length && !this.displayServiceImages;j++)
                if (this.categoriesView[j].imageDisplayed!==this.imageDisplayed)
                    this.displayCureImages = true;

            if (forceTo!==undefined && forceTo!="")
                this.displayType=forceTo;
            else
                if (this.displayCureImages)
                    this.displayType="thumbnail";
                else
                    this.displayType="array";
        };

        CureCategoryView.prototype.populateDisplayTypeResource = function(array)
        {
            var defaultDType =  this.displayCureImages ? "thumbnail" : "array";
            if (this.displayType!=defaultDType)
            {
                var cat = this.getModel();
                if (cat)
                    array.push({id:cat.id,type:this.displayType});
            }
            for (var i=0;i< this.categoriesView.length;i++)
                this.categoriesView[i].populateDisplayTypeResource(array);
        };

        return CureCategoryView;
}]);



// WEBPACK FOOTER //
// ./js/services/views/CureCategoryView.js